// The app's one <video> for media files (cast file player, wall full-screen viewer).
import { forwardRef, type VideoHTMLAttributes } from "react";

export interface VideoPlayerProps extends VideoHTMLAttributes<HTMLVideoElement> {
  testId?: string;
}

const VideoPlayer = forwardRef<HTMLVideoElement, VideoPlayerProps>(function VideoPlayer({ testId, ...rest }, ref) {
  return <video ref={ref} data-testid={testId} {...rest} />;
});

export default VideoPlayer;
